import { useRef, useEffect } from 'react'
import { useStore, useSelector } from 'react-redux'

export const useConnect = onConnect => {
  const called = useRef(false)
  const store = useStore()
  if (called.current) {
    return
  }
  called.current = true
  setTimeout(() => onConnect(store), 1)
}

/**
 * @function
 * @description Calls a function based on a redux change.
 * @param {Function} selector Redux selector to watch for a change to the redux store.
 * @param {Function} reactionFunction Function to call when the target redux change occurs.
 * @param {boolean} useOnFirstCall By default, the reactionFunction is not called on the first call. This overrides that behavior.
 * @param {Function} reduxCompareFunction See redux useSelector.
 */
export const useReduxChange = (selector, reactionFunction, useOnFirstCall, reduxCompareFunction) => {
  const firstCall = useRef(true)
  const reduxValue = useSelector(selector, reduxCompareFunction)
  useEffect(() => {
    // This is called the first time when the react function is first called. You should already have logic for that.
    if (!firstCall.current || useOnFirstCall) {
      reactionFunction(reduxValue)
    }
    firstCall.current = false
  }, [reduxValue])
}
